import { useEffect, useState } from 'react';

export const useGlobalZoomLevel = (defaultValue = 1) => {
  const [zoom, setZoom] = useState(defaultValue);

  useEffect(() => {
    const root = document.documentElement;
    const value = getComputedStyle(root)
      .getPropertyValue('--global-zoom-level')
      .trim();

    if (value) {
      const parsed = Number(value);
      if (!Number.isNaN(parsed)) {
        setZoom(parsed);
      }
    }
  }, []);

  return zoom;
};
